export const SPECIAL_PAGE_PREFIX = '/page';

export function getSpecialPageUrl(specialPage, params) {
    let result = `${SPECIAL_PAGE_PREFIX}/${specialPage}`;
    if (!params || params.length === 0) {
        return result;
    }
    return params.reduce((url, param) => url + `&${param.key}=${param.value}`, `${result}?`);
}

export function goToSpecialPage(specialPage, ...params) {
    location.assign(getSpecialPageUrl(specialPage, params));
}
